import { render, staticRenderFns } from "./TestTwo.vue?vue&type=template&id=d2d9dbf2&scoped=true"
import script from "./TestTwo.vue?vue&type=script&lang=js"
export * from "./TestTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d9dbf2",
  null
  
)

export default component.exports